<template>
  <div>
    <el-dialog
      id="edit-modal"
      class="form-modal"
      v-loading="editProcessing"
      :visible.sync="editVisible"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
    >
      <div id="edit-modal-header" class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <div>
            <el-button
              v-if="showIntercomButton"
              class="h-[30px]"
              type="default"
              @click="toggleIntercom"
            >
              Need Help?
            </el-button>
          </div>
          <h1 class="modal-title col-2">
            Update {{ this.numberFormatter(editForm.number) }}
          </h1>
          <div class="modal-actions col-2">
            <el-button type="primary" @click="updateNumber">Save</el-button>
            <el-button
              type="default"
              class="hidden-xs-only"
              @click="cancelOperation"
              >Cancel</el-button
            >
            <el-button
              type="default"
              icon="el-icon-close"
              class="hidden-sm-and-up"
              @click="cancelOperation"
            ></el-button>
          </div>
        </div>
      </div>

      <el-form>
        <recent-audits service="Phone Number" :record="currentRecord" />
        <el-tabs v-model="activeTabName">
          <el-tab-pane name="general" label="General">
            <el-input
              v-model="editForm.diCommentName"
              placeholder="Enter description"
            >
              <template slot="prefix">Description</template>
            </el-input>

            <div class="inline-form-group">
              <el-input
                :value="editForm.callerId"
                @input="editForm.callerId = sanitizeCallerId($event)"
                placeholder="Enter caller ID name"
                maxlength="14"
                show-word-limit
              >
                <template slot="prefix">Caller ID name</template>
              </el-input>
            </div>
            <div class="inline-form-group">
              <el-tag class="mb-10" type="primary">
                <i class="el-icon-warning" style="margin-right: 4px" />
                This is the name that shows up on caller id when dialing
                external. Limited to 14 characters.
              </el-tag>
            </div>

            <dads-select
              v-model="editForm.branchId"
              placeholder="Select a branch"
              filterable
            >
              <template slot="prefix">Branch</template>
              <el-option
                v-for="(item, index) in branchOptions"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </dads-select>

            <div class="inline-form-group">
              <el-col :span="11">
                <el-input
                  v-model="editForm.namePrefix"
                  placeholder="Enter prefix name"
                >
                  <template slot="prefix">Prefix name</template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="12">
                <el-select
                  v-if="!isFax"
                  v-model="editForm.recording"
                  :value="editForm.recording"
                  placeholder="Select option"
                >
                  <template slot="prefix">Enable recording</template>
                  <el-option
                    v-for="(option, index) in recordingOptions"
                    :key="index"
                    :value="option.value"
                    :label="option.label"
                  />
                </el-select>
              </el-col>
            </div>

            <div class="inline-form-group">
              <el-tag class="mb-10" type="primary">
                <i class="el-icon-warning" style="margin-right: 4px" />
                This will show up on your caller ID in addition to the callers
                name
              </el-tag>
            </div>

            <div
              v-if="
                editForm.recording === 'yes' ||
                editForm.recording === 'yeschange' ||
                editForm.recording === 'nochange'
              "
            >
              <h2 class="form-section-header">Email recording</h2>
              <el-input
                v-model="editForm.emailRecording"
                placeholder="Enter emails"
              >
                <template slot="prefix"> Emails </template>
              </el-input>
            </div>
          </el-tab-pane>
          <el-tab-pane name="routing" label="Routing">
            <h2 class="form-section-header">Select type</h2>
            <div class="mt-10">
              <el-radio-group v-model="isFax">
                <el-radio-button :label="false">Voice</el-radio-button>
                <el-radio-button :label="true">Fax</el-radio-button>
              </el-radio-group>
            </div>
            <div class="mt-10">
              <div v-if="isFax">
                <h2 class="form-section-header">Fax settings</h2>
                <el-checkbox v-model="faxStore"
                  >Enable fax storage after delivery</el-checkbox
                >
                <div class="mt-10">
                  <el-radio-group v-model="editForm.fax">
                    <el-radio class="black-text" label="force"
                      >Deliver to email</el-radio
                    >
                    <el-radio class="black-text" label="forcestoreandforward"
                      >Deliver to email and forward to extension
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="mt-10">
                  <dads-select
                    v-if="editForm.fax === 'forcestoreandforward'"
                    v-model="editForm.storeForwardNumber"
                    remote
                    filterable
                    :remote-method="searchExtensions"
                    placeholder="Select an extension"
                  >
                    <template slot="prefix">Forward to</template>
                    <el-option
                      v-for="(item, index) in extOptions"
                      :key="item.key"
                      :value="item.number"
                      :label="item.name + ' - ' + item.number"
                    />
                  </dads-select>
                </div>
                <el-input
                  v-model="editForm.faxEmail"
                  placeholder="Enter emails"
                >
                  <template slot="prefix">Fax emails</template>
                </el-input>
                <el-tag class="mb-10" type="primary">
                  <i class="el-icon-warning" style="margin-right: 4px" />
                  You may enter multiple emails separated by a comma.
                </el-tag>
              </div>
              <destination-selector
                v-if="!isFax"
                :isTerminalDestSelector="true"
                :draggable="true"
                :showHeader="false"
                :draggableDestTypes="draggableDestTypes"
                :include-pharmacy-dests="true"
                :include-pharmacy-agents="true"
                :selectedDestinations="editForm.didDestinations"
                :clearFields="clearFields"
                @destinationsSelected="onDidDestinationsSelection"
                title=""
              />
              <h2 class="form-section-header">Unconditional forwarding</h2>
              <el-checkbox v-model="editForm.unconditionalStatus"
                >Enable unconditional forwarding</el-checkbox
              >
              <div v-if="editForm.unconditionalStatus">
                <h2 class="form-section-header">Unconditional Destinations</h2>
                <destination-selector
                  :isTerminalDestSelector="true"
                  :draggable="true"
                  :showHeader="false"
                  :draggableDestTypes="draggableDestTypes"
                :include-pharmacy-dests="true"
                :include-pharmacy-agents="true"
                  :selectedDestinations="editForm.unconditionalDestinations"
                  :clearFields="clearFields"
                  @destinationsSelected="onUnconditionalDestinationsSelection"
                  title=""
                />
              </div>

              <div>
                <h2 class="form-section-header">SMS settings</h2>
                <div class="mt-5 mb-5">
                  <div
                    class="inline-form-group"
                    v-if="brandId || campaignId"
                    v-loading="loadingTnDetail"
                  >
                    <el-col :span="9">
                      <el-checkbox
                        v-if="brandId"
                        :value="enabledForText"
                        @change="handleToggleTexting"
                      >
                        Enable for text messaging
                      </el-checkbox>
                    </el-col>
                    <el-col :span="1" />
                    <el-col :span="11">
                      <el-tag v-if="campaignId" class="ml-5">
                        Campaign Id: {{ campaignId }}
                      </el-tag>
                    </el-col>
                  </div>
                </div>
                <el-tag class="mb-10" type="primary">
                  <i class="el-icon-warning" style="margin-right: 4px" />
                  This process can take a while
                </el-tag>

                <destination-selector
                  :isTerminalDestSelector="true"
                  :draggable="true"
                  :showHeader="false"
                  :draggableDestTypes="['EXT']"
                  :include-pharmacy-agents="true"
                  :selectedDestinations="editForm.smsDestinations"
                  :clearFields="clearFields"
                  @destinationsSelected="onSMSDestinationsSelection"
                  title=""
                />
                <h4
                  v-if="!canEnableTexting && !loadingTnDetail"
                  class="form-section-header"
                >
                  Text messaging features are not configured for your account.
                  Contact support for assistance.
                </h4>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import DestinationSelector from "@/components/DestinationSelector.vue";
import RecentAudits from "@/components/RecentAudits";
import DadsSelect from "@/components/select";
import { apiV2Host } from "@/feathers/feathers-client";
import { isWhiteLabel, phoneNumberFormatter } from "@/globals/globals";

export default {
  name: "DidsEditForm",

  props: {
    currentRecord: { required: true },
    editProcessing: {
      required: true,
    },
    clearFields: { required: true },
    editVisible: { required: true },
    branchOptions: { required: true },
    recordingOptions: { required: true },
  },

  components: {
    DestinationSelector,
    DadsSelect,
    RecentAudits,
  },

  data() {
    return {
      campaignId: "",
      showGetHelp: false,
      enableIntercom: true,
      activeTabName: "general",
      campaignList: [],
      enabledForText: null,
      assignedToCampaign: null,
      originalCallerId: "",
      registeredCNAM: "",
      findingCallerId: false,
      isFax: null,
      faxStore: false,
      extOptions: [],
      loadingTnDetail: true,
      editForm: {
        number: "",
        callerId: "",
        namePrefix: "",
        recording: "",
        branchId: "",
        didDestinations: [],
        smsDestinations: [],
        unconditionalDestinations: [],
        unconditionalStatus: false,
        diCommentName: "",
        fax: "no",
        faxStore: "no",
        storeForwardNumber: "",
        faxEmail: "",
        emailRecording: "",
        smsExtId: null,
      },
      draggableDestTypes: [
        "SPECIAL",
        "CUSTOM",
        "IVR",
        "VOICEMAIL",
        "PLAYBACK",
        "HUNTLIST",
        "EXT",
        "QUEUE",
        "SMS",
        "MUSICONHOLD",
        "CONDITION",
        "MEETME",
      ],
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    brandId() {
      return !!this.selectedTenant.brandId;
    },

    unconditionalStatus() {
      return this.editForm.unconditionalStatus;
    },

    canEnableTexting() {
      if (this.campaignList.length) {
        let campaignSlot = this.findDcaApprovedCampaignWithSlots();
        return this.brandId && !!campaignSlot;
      }
      return false;
    },

    whiteLabel() {
      return isWhiteLabel();
    },

    showIntercomButton() {
      return (
        (this.showGetHelp || !this.canEnableTexting) &&
        !this.loadingTnDetail &&
        this.activeTabName === "routing" &&
        !this.whiteLabel
      );
    },
  },

  watch: {
    async currentRecord(val) {
      if (val) {
        this.populateFields(val);
        this.editForm.unconditionalStatus = val.unconditionalStatus === "on";

        // Parse out the different destinations
        const {
          didDestinations,
          smsDestinations,
          unconditionalDestinations,
          registeredCNAM,
        } = val;

        // Routing destinations
        this.editForm.didDestinations = didDestinations;

        // Unconditional forward destinations
        this.editForm.unconditionalDestinations = unconditionalDestinations;

        this.editForm.smsDestinations = smsDestinations.map((item) => {
          item.type = item.type === "SMS" ? "EXT" : item.type;
          return item;
        });

        // The registered CNAM is our source of truth for the caller ID name.
        this.editForm.callerId = registeredCNAM || "";
        this.originalCallerId = registeredCNAM || "";

        // Still hit Inteliquent for the messaging/campaign details.
        let params = {
          query: { context: "numberDetails", number: this.editForm.number },
        };

        try {
          this.loadingTnDetail = true;
          const response = await feathersClient
            .service("tn-ordering")
            .find(params);
          const tnFeature = response[0].tnFeature;
          const messagingFeature = tnFeature.messaging;

          this.enabledForText = !!messagingFeature.msgCampaignId;
          this.assignedToCampaign = !!messagingFeature.msgCampaignId;
          this.campaignId = messagingFeature.msgCampaignId;
        } catch (error) {
        } finally {
          // Fetch the campaign list if not assigned to a campaign and a brandId exists
          if (this.brandId) {
            try {
              const response = await fetch(
                `${apiV2Host}/admin/tcr/campaigns?tenantId=${val.tenantId}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer " + this.$store.state.auth.accessToken,
                  },
                }
              );

              if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
              }

              this.campaignList = await response.json();
            } catch (error) {}
          }

          this.loadingTnDetail = false;
        }
      }
    },

    isFax() {
      if (this.isFax) {
        this.editForm.fax =
          this.editForm.fax === "no" ? "force" : this.editForm.fax;
      }
    },

    clearFields(val) {
      if (val) {
        this.clearFormFields();
      }
    },
  },

  methods: {
    // CNAM is written to cc_cnamecache and sent in outbound SIP headers; some
    // carriers reject special characters, so only allow letters, digits and spaces.
    sanitizeCallerId(value) {
      return (value || "").replace(/[^A-Za-z0-9 ]/g, "");
    },

    numberFormatter(number) {
      return phoneNumberFormatter(number);
    },

    cancelOperation() {
      this.$emit("cancelOperation");
    },

    updateNumber() {

      this.editForm.faxStore = this.faxStore ? "yes" : "no";

      if (!this.isFax) {
        this.editForm.fax = "no";
      }

      const editBody = { ...this.editForm };
      // registeredCNAM is our source of truth - post it so inteliquent gets updated.
      editBody.registeredCNAM = this.sanitizeCallerId(this.editForm.callerId);
      editBody.tenantId = this.selectedTenant.id;
      editBody.unconditionalStatus = editBody.unconditionalStatus ? "on" : "";

      switch (editBody.recording) {
        case "yes":
        case "yeschange":
          editBody.recording = "yeschange";
          break;
        default:
          break;
      }

      const didDestinations = this.validateDestinations(
        editBody.didDestinations,
        "DID"
      );

      const unconditionalDestinations = this.validateDestinations(
        editBody.unconditionalDestinations,
        "UNCONDITIONAL"
      );

      const smsDestinations = this.validateDestinations(
        editBody.smsDestinations,
        "SMS"
      );

      if (didDestinations && unconditionalDestinations && smsDestinations) {
        editBody.didDestinations = didDestinations;
        editBody.unconditionalDestinations = unconditionalDestinations;
        editBody.smsDestinations = smsDestinations;
      } else {
        return;
      }

      this.$emit("updateNumber", editBody);
    },

    validateDestinations(destinations, type) {
      if (destinations.length > 1 && destinations.find((dst) => !dst.id)) {
        this.$notify({
          title: `Empty ${type} Destination field`,
          message: "Don't leave any destination field to be empty.",
          type: "error",
        });
        return;
      }

      let finalDestinations = [];
      if (destinations.length === 1 && destinations[0].id === null) {
        return finalDestinations;
      }

      if (destinations.length) {
        destinations.forEach((dst, idx) => (dst.order = idx + 1));

        finalDestinations = destinations.map(({ id, type, order }) => ({
          id,
          type,
          order,
        }));
      }
      return finalDestinations;
    },

    deleteRecord(id) {
      this.$emit("deleteRecord", id);
    },

    populateFields(record) {
      for (let key in record) {
        if (record.hasOwnProperty(key)) {
          if (this.editForm.hasOwnProperty(key)) {
            this.editForm[key] = record[key];
          }
        }
      }
      this.isFax = record.isFax;

      if (this.isFax) {
        const faxTypes = ["force", "forcestoreandforward"];
        this.editForm.fax = faxTypes.includes(this.editForm.fax)
          ? this.editForm.fax
          : "force";
      }

      this.faxStore = this.editForm.faxStore === "yes";
      this.editForm.emailRecording = record.emailRecording;

      //get the current extension
      feathersClient
        .service("extensions")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            number: this.editForm.storeForwardNumber,
          },
        })
        .then((res) => {
          if (res.length) {
            this.extOptions.push({
              key: this.getRandomKey(),
              name: res[0].name,
              number: res[0].number,
            });
          }
        });
    },

    searchExtensions(query) {
      if (query.length) {
        const searchTerm = (query + "")
          .replace(/[\\"']/g, "\\$&")
          .replace(/\u0000/g, "\\0");

        feathersClient
          .service("extensions")
          .find({
            query: {
              tenantId: this.selectedTenant.id,
              $or: [
                { number: { $like: `%${searchTerm}%` } },
                { name: { $like: `%${searchTerm}%` } },
              ],
              $limit: 25,
            },
          })
          .then((res) => {
            this.extOptions = res.map((item) => {
              return {
                key: this.getRandomKey(),
                name: item.name,
                number: item.number,
              };
            });
          });
      }
    },

    getRandomKey() {
      const randomString = () => Math.random().toString(36).slice(2);
      return `${randomString()}-${randomString()}$${randomString()}`;
    },

    clearFormFields() {
      this.activeTabName = "general";
      this.originalCallerId = "";
      this.isFax = null;
      this.extOptions = [];
      this.faxStore = false;
      this.editForm = {
        number: "",
        callerId: "",
        namePrefix: "",
        recording: "",
        branchId: "",
        didDestinations: [],
        smsDestinations: [],
        unconditionalDestinations: [],
        unconditionalStatus: false,
        diCommentName: "",
        fax: "no",
        faxStore: "no",
        storeForwardNumber: "",
        faxEmail: "",
        smsExtId: null,
      };
    },

    onDidDestinationsSelection(destinations) {
      this.editForm.didDestinations = [...destinations];
    },

    onUnconditionalDestinationsSelection(destinations) {
      this.editForm.unconditionalDestinations = [...destinations];
    },
    onSMSDestinationsSelection(destinations) {
      this.editForm.smsDestinations = [...destinations];
      // smsExtId drives inbound user routing, so only an extension may claim
      // it; agent (IVA) destinations route via the destinations table instead
      const [first] = destinations;
      this.editForm.smsExtId = first && first.type === "EXT" ? first.id : null;
    },

    async handleToggleTexting(enabled) {
      this.loadingTnDetail = true;
      enabled
        ? await this.enableTexting(enabled)
        : await this.disableTexting(enabled);
      this.loadingTnDetail = false;
    },
    async enableTexting() {
      const campaign = this.findDcaApprovedCampaignWithSlots();

      if (!campaign) {
        this.$notify({
          title: "Warning",
          message: "Could Not Provision Phone Number.",
          type: "warning",
        });
        return;
      }

      const { externalCampaignId: campaignId } = campaign;

      const postBody = {
        number: this.editForm.number,
        campaignId: campaignId,
        enabled: 1,
      };
      try {
        const response = await fetch(
          `${apiV2Host}/admin/phone-numbers/sms/provision`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
            },
            body: JSON.stringify(postBody),
          }
        );

        const data = await response.json();
        if (!response.ok) {
          this.$notify({
            title: "Warning",
            message: `Error: ${data.message}`,
            type: "warning",
          });
          return;
        }

        this.enabledForText = true;
        this.assignedToCampaign = true;
        this.campaignId = campaignId;
      } catch (error) {
        this.$notify({
          title: "Warning",
          message: `Error: ${error.message}`,
          type: "warning",
        });
        this.showGetHelp = true;
      }
    },
    async disableTexting() {
      const postBody = {
        number: this.editForm.number,
        enabled: 0,
      };

      try {
        const response = await fetch(
          `${apiV2Host}/admin/phone-numbers/sms/provision`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
            },
            body: JSON.stringify(postBody),
          }
        );

        const data = await response.json();
        if (!response.ok) {
          this.$notify({
            title: "Warning",
            message: `Error: ${data.message}`,
            type: "warning",
          });
          return;
        }

        this.enabledForText = false;
        this.campaignId = "";
        this.assignedToCampaign = false;
      } catch (error) {
        this.$notify({
          title: "Warning",
          message: `Error: ${error.message}`,
          type: "warning",
        });
        this.showGetHelp = true;
      }
    },
    findDcaApprovedCampaignWithSlots() {
      for (let i = 0; i < this.campaignList.length; i++) {
        if (
          this.campaignList[i].isDcaApproved === "Y" &&
          this.campaignList[i].tnAssignedCount < 49
        ) {
          return this.campaignList[i];
        }
      }
      return null;
    },
    toggleIntercom() {
      this.enableIntercom = !this.enableIntercom;
      this.enableIntercom ? this.hideIntercom() : this.showIntercom();
    },
    hideIntercom() {
      window.Intercom("hide");
    },
    showIntercom() {
      window.Intercom("show");
    },
    mounted() {
      window.Intercom("onHide", () => {
        this.enableIntercom = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  max-width: 600px;
  margin: 0 auto;
}

.el-checkbox {
  margin: 0;
}

.modal-footer-actions {
  position: fixed;
  right: 50px;
  bottom: 50px;
}

.sms-section-header {
  color: #fff;
  margin-top: 0;
  margin-bottom: 4px;
}
</style>
